import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=7c6a0f3c&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=7c6a0f3c&prod&lang=sass"
import style1 from "./Register.vue?vue&type=style&index=1&id=7c6a0f3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a0f3c",
  null
  
)

export default component.exports